import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Form } from "./Form";
import { Table } from "./Table";

export interface ICountry {
    country_ID?: number,
    country_Name?: string,
    description?: string
}
export const EmptyCountry: ICountry = {
    country_ID: undefined,
    country_Name: "",
    description: ""
}

export interface IModel {
    open: boolean,
    singleData: ICountry
}

export const Country = ({ setTab }: { setTab: (tab: number) => void }) => {

    const [modal, setModal] = useState({ singleData: EmptyCountry, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyCountry, open: false })
    };

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table setTab={setTab} setModal={setModal} toast={toast} reload={reload}></Table>
            <Toast ref={toast} />
        </>
    );
}
